import { render, staticRenderFns } from "./HolidaysEntitlementItem.vue?vue&type=template&id=0cda9c31&"
import script from "./HolidaysEntitlementItem.vue?vue&type=script&lang=js&"
export * from "./HolidaysEntitlementItem.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysEntitlementItem.vue?vue&type=style&index=0&id=0cda9c31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports